export function redirectToURL(url: string): void {
  // This is a workaround to redirect the user with 'noreferrer' rel attribute.
  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noreferrer';
  a.click();
}

const POLICY_PATTERN = /LP([a-zA-Z0-9]+)/;

export function getPolicyParam(): string {
  const match = POLICY_PATTERN.exec(window.location.href);

  if (match) {
    return match[0];
  }

  return '';
}
